import Http from "./Http";

class DynamicWidgetsService extends Http {
    static $displayName = "DynamicWidgetsService";

    async getAdminsWidgets() {
        return await this.get(`/admins/widgets`);
    }

    async postAdminsWidget(data) {
        return await this.post(`/admins/widgets`, data);
    }

    async editAdminsWidget(id, data) {
        return await this.put(`/admins/widgets/${id}`, data);
    }
    
    async deleteAdminsWidget(id) {
        return await this.delete(`/admins/widgets/${id}`);
    }
}

export default DynamicWidgetsService;